import { Controller } from "@hotwired/stimulus"

// Dynamiczne kroki polityki eskalacji: dodawanie/usuwanie wierszy z template
// oraz przełączanie selecta adresata (użytkownik/grupa) zależnie od notify_type.
// Ukryty select jest disabled, żeby jego notify_id nie trafiał do parametrów.
export default class extends Controller {
  static targets = ["list", "template"]

  connect() {
    this.counter = this.rows().length
    this.rows().forEach((row) => {
      this.toggleNotify(row)
      this.toggleChannel(row)
    })
  }

  add() {
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, this.counter)
    this.counter++
    this.listTarget.insertAdjacentHTML("beforeend", html)
    const rows = this.rows()
    this.toggleNotify(rows[rows.length - 1])
    this.toggleChannel(rows[rows.length - 1])
  }

  remove(event) {
    event.target.closest(".step-row").remove()
  }

  notifyTypeChanged(event) {
    this.toggleNotify(event.target.closest(".step-row"))
  }

  channelChanged(event) {
    this.toggleChannel(event.target.closest(".step-row"))
  }

  rows() {
    return Array.from(this.listTarget.querySelectorAll(".step-row"))
  }

  toggleNotify(row) {
    const type = row.querySelector("[data-notify-type]").value
    this.toggleWrap(row.querySelector("[data-notify-user]"), type === "user")
    this.toggleWrap(row.querySelector("[data-notify-group]"), type === "group")
  }

  // select konektora widoczny tylko dla kanału "connector"
  toggleChannel(row) {
    const channel = row.querySelector("[data-channel]").value
    this.toggleWrap(row.querySelector("[data-channel-connector]"), channel === "connector")
  }

  toggleWrap(wrap, visible) {
    if (!wrap) return
    wrap.classList.toggle("hidden", !visible)
    wrap.querySelector("select").disabled = !visible
  }
}
